import { jwtDecode } from 'helpers/jwt';
import LocalStorageService from 'services/localStorage/LocalStorageService';

export const TOKEN_KEY = 'token';

const TokenService = {
  getToken() {
    return LocalStorageService.getItem(TOKEN_KEY);
  },
  setToken(token) {
    LocalStorageService.setItem(TOKEN_KEY, token);
  },
  removeToken() {
    LocalStorageService.clear(TOKEN_KEY);
  },
  getTokenPayload() {
    const token = this.getToken();
    if (!token) return null;

    const { sub, exp } = jwtDecode(token);

    return { sub, exp };
  },
  isTokenExpired(exp) {
    if (!exp) return true;
    return Date.now() >= exp * 1000;
  },
};

export default TokenService;
